const fetchGoogleTaxonomy = () => {
  const base = import.meta.env.VITE_BASENAME;

  const apiURL = `${base ? `${base}` : ''}/json/googleTaxonomy.en-US.json`;
  return window
    .fetch(apiURL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((res) => res.json());
};

export default fetchGoogleTaxonomy;
